// extracted by mini-css-extract-plugin
export default {"root":"DeleteConfirmModal_root__cH4E0","buttonGroup":"DeleteConfirmModal_buttonGroup__T3DWk"};